import { render, staticRenderFns } from "./RegistrationStep4.vue?vue&type=template&id=412c92f4&scoped=true"
import script from "./RegistrationStep4.vue?vue&type=script&lang=js"
export * from "./RegistrationStep4.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep4.vue?vue&type=style&index=0&id=412c92f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c92f4",
  null
  
)

export default component.exports